import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { doGetAllOrdersDispatched, doGetCountOrdersDispatchedByCompany } from "./thunk";

const isActionWithPending = action => {
  return action.type.startsWith("reports/") && action.type.endsWith("/pending");
};

const isActionWithFulfilled = action => {
  return action.type.startsWith("reports/") && action.type.endsWith("/fulfilled");
};

const isActionWithFailed = action => {
  return action.type.startsWith("reports/") && action.type.endsWith("/rejected");
};

const reportsAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const reportSlice = createSlice({
  name: "report",
  initialState: {
    action: null,
    isFetching: false,
    companies: [],
    countOrdersByCompany: {},
    status: "idle",
    metadata: {},
    entities: [],
    ids: [],
    item: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllOrdersDispatched.pending, state => {
      state.action = "getall";
      state.status = "loading";
    });
    builder.addCase(doGetAllOrdersDispatched.fulfilled, (state, action) => {
      const { orders, meta } = action.payload;
      state.status = "succeeded";
      state.metadata = meta;
      reportsAdapter.setAll(state, orders);
    });
    builder.addCase(doGetAllOrdersDispatched.rejected, state => {
      state.status = "failed";
    });

    builder.addCase(doGetCountOrdersDispatchedByCompany.pending, state => {
      state.action = "getCountOrdersByCompany";
      state.status = "loading";
    });
    builder.addCase(doGetCountOrdersDispatchedByCompany.fulfilled, (state, action) => {
      const { companies, ordersByCompany, meta } = action.payload;
      state.status = "succeeded";
      state.metadata = meta;
      state.companies = companies;
      state.countOrdersByCompany = ordersByCompany;
    });
    builder.addCase(doGetCountOrdersDispatchedByCompany.rejected, state => {
      state.status = "failed";
    });

    builder.addMatcher(isActionWithPending, state => {
      state.isFetching = true;
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, state => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, state => {
      state.isFetching = false;
      state.message = null;
    });
  },
});

export const {
  selectAll: selectAllReports,
  selectById: selectReportById,
  selectIds: selectReportIds,
} = reportsAdapter.getSelectors(state => state.report);

const { reducer: reportReducer } = reportSlice;
export default reportReducer;
